import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderQuoteService } from '../../services/order-quote.service';
import { ActivatedRoute } from '@angular/router';
import { OrderQuoteConfirmationDTO } from '../../interfaces/order-quote-confirmation';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-b2c-confirmation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './b2c-confirmation.component.html',
  styleUrls: ['./b2c-confirmation.component.scss'],
})
export class B2cConfirmationComponent implements OnInit {
  quoteConfirmation: OrderQuoteConfirmationDTO;
  isLoading: boolean = true;

  constructor(private orderQuoteService: OrderQuoteService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params
      .pipe(
        switchMap((params) => {
          return this.orderQuoteService.getOrderQuoteConfirmation(params['id']);
        }),
      )
      .subscribe((quoteConfirmation: OrderQuoteConfirmationDTO) => {
        this.quoteConfirmation = quoteConfirmation;
        this.isLoading = false;
      });
  }
}
